module.exports = __webpack_public_path__ + "img/comming_soon2.9529899c.png";